import { render, staticRenderFns } from "./LoginCardDescription.vue?vue&type=template&id=41548ed9&scoped=true&"
import script from "./LoginCardDescription.vue?vue&type=script&lang=ts&"
export * from "./LoginCardDescription.vue?vue&type=script&lang=ts&"
import style0 from "./LoginCardDescription.vue?vue&type=style&index=0&id=41548ed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41548ed9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VContainer,VDivider})
